import React from 'react'
import { When } from 'react-if'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { TitleMD } from '@/atoms/Text'
import { GuildUpdatesPortraitRowCollection } from '@/page/GuildUpdatesPortraitRowCollection'
import { useWatchProjectContext } from '@/services/ProjectsService/WatchProjectProvider'
import { Note, ThankYouNote, UserStory } from '@/services/StoriesService'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { CommunityVideosList } from './CommunityVideosList'

interface CommunityTabProps {
  singleStory?: boolean
  story?: ThankYouNote | UserStory
  communityStories?: Note[]
}

export const CommunityTab: React.FC<CommunityTabProps> = ({ communityStories }) => {
  const { t } = useTranslate('watch')
  const { isGuildMember } = useWatchProjectContext()

  return (
    <div className="flex flex-col pt-[72px]">
      <CommunityVideosList communityStories={communityStories} />
      <When condition={isGuildMember}>
        <div className="my-6 mt-[72px] flex flex-row flex-wrap items-center">
          <PaddedContainer fluid>
            <TitleMD aria-label="community-tab-header" weight="bold" className="md:photon-title-md mr-auto">
              <Translate t={t} i18nKey="guildUpdates">
                Guild Updates
              </Translate>
            </TitleMD>
          </PaddedContainer>
        </div>
        <PaddedContainer fluid>
          <GuildUpdatesPortraitRowCollection />
        </PaddedContainer>
      </When>
    </div>
  )
}
